

const NotNull = (value, error = ' To pole nie może być puste!') =>
  value === null || value == '' || value == ' ' ? error : null;

const NotSelected = (value, error = ' Wybierz jedną z opcji') =>
  value === null || value == '' || value == ' ' ? error : null;

const ExatctLength = (length = 5, error = null) =>
  (value, error_text = error ? error : ' To pole musi mieć dokładnie ' + length + ' znaków!') =>
    value && value.length !== length ? error_text : null;

const MinLength = (min_length = 5, error = null) =>
  (value, error_text = error ? error : ' To pole musi mieć co najmniej ' + min_length + ' znaków!') =>
    value === null || value.length < min_length ? error_text : null;

const MaxLength = (max_length = 5, error = null) =>
  (value, error_text = error ? error : ' To pole nie może być dłuższe niż ' + max_length + ' znaków!') =>
    value === null || value.length > max_length ? error_text : null;

const CheckWieczysta = (value, error = ' Wpisano błędny numer księgi wieczystej!') => {
  let re = /^[a-zA-Z]{2}[a-zA-Z0-9]{2}\/[0-9]{8}\/[0-9]{1,}$/
  return re.test(value) ? null : error;
}

const isNumber = (value, error = " Wartośc musi być liczbą! ") =>
  !isNaN(value) ? null : error;

const CheckDate= (value, error = " Niepoprawna data!") => {
  const re = /(((0[1-9]|[12][0-9]|3[01])([-])(0[13578]|10|12)([-])(\d{4}))|(([0][1-9]|[12][0-9]|30)([-])(0[469]|11)([-])(\d{4}))|((0[1-9]|1[0-9]|2[0-8])([-])(02)([-])(\d{4}))|((29)(\.|-|\/)(02)([-])([02468][048]00))|((29)([-])(02)([-])([13579][26]00))|((29)([-])(02)([-])([0-9][0-9][0][48]))|((29)([-])(02)([-])([0-9][0-9][2468][048]))|((29)([-])(02)([-])([0-9][0-9][13579][26])))/
  return re.test(value) ? null : error;

}

const CheckEmail = (value, error = ' Niepoprawny email!') => {
  let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return value === null || value == '' || re.test(value) ? null : error;
}

const CheckNIP = (value, error = ' NIP jest nieprawidłowy!') => {
  if (value == null) {
    return null;
  }

  const digitReg = /[^0-9]/g;
  if (digitReg.test(value)) {
    error = ' NIP musi zawierać tylko cyfry!';
    return error;
  }
  if (value.length > 0) {
    if (['0000000000'].includes(value)) {
      error = ' NIP jest nieprawidłowy!';
      return error;
    }
    const wagiNIP = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    // Mnozymy liczby przez
    let resultNIP = 0;
    for (let i = 0; i < 9; i++) {
      resultNIP += value[i] * wagiNIP[i];
    }
    resultNIP %= 11;
    if (value.length != 10) {
      error = ' NIP powinien mieć 10 liczb!';
      return error;
    }
    if (value[9] != resultNIP) {
      error = ' NIP jest nieprawidłowy!';
      return error;
    }
  }
  return null;
}
const checkControlSum = (wagi, numer, modulo) => {
  let checksum = 0;
  for (let i = 0; i < wagi.length; i += 1) {
    checksum += parseInt(numer.substring(i, i + 1), 10) * wagi[i];
  }
  checksum %= modulo;
  if (checksum === 10) checksum = 0; // jeśli wynik z modulo 11 jest 10
  if (parseInt(numer.substring(numer.length - 1, numer.length), 10) !== checksum) {
    return false;
  }
  return true;
};

const CheckREGON = (value, error = ' Nieprawidłowy REGON!') => {
  if (value == null) {
    return null;
  }

  const digitReg = /[^0-9]/g;
  if (digitReg.test(value)) {
    error = ' REGON musi zawierać tylko cyfry!';
    return error;
  }

  if (['000000000', '00000000000000'].includes(value)) {
    error = ' Nieprawidłowy REGON!';
    return error;
  }

  const wagiNa7 = [2, 3, 4, 5, 6, 7];
  const wagiNa9 = [8, 9, 2, 3, 4, 5, 6, 7];
  const wagiNa14 = [2, 4, 8, 5, 0, 9, 7, 3, 6, 1, 2, 4, 8];

  switch (value.length) {
    case 0:
      return null;
    case 9:
      // najpierw stare numery niegdyś 7-cyfrowe z dwoma zerami na początku:
      if (parseInt(value.substring(0, 2), 10) === 0) {
        if (!checkControlSum(wagiNa7, value.substring(2, 9), 11)) {
          error = ' Nieprawidłowy REGON!';
          return error;
        }
      }
      // nowe numery:
      if (!checkControlSum(wagiNa9, value, 11)) {
        error = ' Nieprawidłowy REGON!';
        return error;
      }
      break;
    case 14:
      // najpierw weryfikacja pierwszych 9 cyfr:
      if (!checkControlSum(wagiNa9, value.substring(0, 9), 11)) {
        error = ' Nieprawidłowy REGON!';
        return error;
      }
      // teraz weryfikacja całego 14-cyfrowego numeru
      if (!checkControlSum(wagiNa14, value, 11)) {
        error = ' Nieprawidłowy REGON!';
        return error;
      }
      break;
    default:
      error = ' REGON powinien mieć 9 lub 14 cyfr!';
      return error;
  }
  return null;
}

export default {
  NotNull,
  NotSelected,
  MinLength,
  MaxLength,
  CheckWieczysta,
  isNumber,
  CheckEmail,
  CheckNIP,
  CheckREGON,
  CheckDate,
  ExatctLength
};


// WEBPACK FOOTER //
// src/routes/eservices/validators.js